<template>
    <div>
        <div class="head">
            <div class="name">
                <div class="oimg">
                    <img src="../assets/img/logo.png" alt />
                </div>
                <div class="spa">e博视智慧配电在线监测系统</div>
            </div>
            <div class="tatel">
                <div class="miti">

                </div>
                <div class="mixin"></div>
            </div>
        </div>
        <div class="cinema">
            <div class="content">
                <div class="nav">
                    <div class="nav-left">
                        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
                            <!-- <el-tab-pane label="9/20" name="first"></el-tab-pane>
          <el-tab-pane label="9/21" name="second"></el-tab-pane>
          <el-tab-pane label="9/22" name="third"></el-tab-pane>-->
                            <el-tab-pane v-for="(item, index) in tableData1" :key="index" :label="item.name"
                                :name="item.name"></el-tab-pane>
                        </el-tabs>
                        <!-- <div
          class="button"
          :style="first == 1 || first == 0 ? 'cursor:not-allowed;color:#ccc' : '' "
          @click="prev"
        >9/20</div>
        <div
          class="button"
          :style="first == 1 || first == 0 ? 'cursor:not-allowed;color:#ccc' : '' "
          @click="prev"
        >9/21</div>
        <div
          class="button"
          :style="first == 1 || first == 0 ? 'cursor:not-allowed;color:#ccc' : '' "
          @click="prev"
        >9/22</div>-->
                    </div>
                    <div class="nav-right">
                        <div v-if="tableData.length !== 0">
                            共
                            <span style="color:#0D94FF">{{ all }}</span>条/每页 <span style="color:#0D94FF">8</span>条
                        </div>
                    </div>
                </div>
                <div class="table column-center" v-if="tableData.length !== 0">
                    <el-table ref="singleTable" :header-cell-style="tableHeaderColor"
                        :row-class-name="tableRowClassName" :data="tableData" :row-style="{ height: '64rem' }" stripe
                        highlight-current-row style="width: 100%;font-weight:100;font-family:'Source Han Sans CN';">
                        <el-table-column type="index" fixed label="序号" width="60"></el-table-column>
                        <el-table-column property="loop_name" fixed label="回路名称" show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column property="device_name" fixed label="设备名称"></el-table-column>
                        <el-table-column property="alarm_event_type" fixed label="事件分类" :formatter="eventType">
                        </el-table-column>
                        <el-table-column property="alarm_type_desc" fixed label="事件类型"></el-table-column>
                        <el-table-column property="start_time" width="160" fixed label="发生时间"
                            :formatter="carTimeFilter"></el-table-column>
                        <el-table-column property="end_time" width="160" fixed label="结束时间" :formatter="carTimeFilter">
                        </el-table-column>
                        <el-table-column property="alarm_type_desc" fixed label="报警描述"></el-table-column>
                    </el-table>
                </div>
                <!-- <div v-else class="row-center tip">
      <img src="../assets/img/not_found_data.png" alt />
    </div>-->
                <div class="mar" v-else>
                    <div class="tors">
                        <div class="Omg">
                            <img src="../assets/img/not_found_data.png" alt />
                        </div>
                        <div class="oP">
                            暂无数据，请尝试
                            <span class="a" @click="add()" style="color:#0D94FF">刷新</span>或切换日期
                        </div>
                    </div>
                </div>
                <!-- <div style="margin-top: 20rem">
      <el-button @click="setCurrent(tableData[1])">选中第二行</el-button>
      <el-button @click="setCurrent()">取消选择</el-button>
    </div>-->
                <div class="pagination" v-if="tableData.length !== 0">
                    <div style="margin-right:31rem" :style="
            first == 1 || first == 0 ? 'cursor:not-allowed;color:#999999' : ''
          " @click="toFirst">
                        首页
                    </div>
                    <div class="button" :style="
            first == 1 || first == 0 ? 'cursor:not-allowed;color:#999999' : ''
          " @click="prev">
                        上一页
                    </div>

                    <div>
                        <el-pagination layout=" pager" :total="all" @current-change="pageCurrentChange"
                            :current-page.sync="currentPage" :page-size="8" :page-count="5"></el-pagination>
                    </div>
                    <div class="button" :style="end == all ? 'cursor:not-allowed;color:#999999' : ''" @click="next">
                        下一页
                    </div>
                    <div style="margin-left:31rem" :style="end == all ? 'cursor:not-allowed;color:#999999' : ''"
                        @click="toEnd">
                        尾页
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
    import chainIndex from "../api/play";
    import moment from "moment";
    export default {
        data() {
            return {
                tableData: [],
                tableData1: [],
                currentRow: null,
                first: 0,
                end: 0,
                all: 0,
                currentPage: 1,

                activeName: "",
            };
        },

        computed: {},
        watch: {},
        created() {
            this.tableDataT();
        },
        mounted() {
            this.tableLocal();
            // this.activeName = this.tableData1[2].name;
            this.all = this.setTableData().length;
            this.getPages();
        },
        beforeDestroy() {
            window.sessionStorage.removeItem("tast");
        },
        methods: {
            setTableData() {
                let data = [];
                this.tableData1.forEach((l) => {
                    if (this.activeName == l.name) {
                        l.devices.map((l) => {
                            data.push(l);
                        });
                    }
                });
                if (data.length === 0) {
                    return [];
                } else {
                    return data;
                }
            },
            tableDataT() {
                chainIndex.eventThreeDay(this.$store.state.proproT.AllId).then((res) => {
                    this.tableData1 = res.data.data.alarms;
                    this.tableLocal();
                    // this.activeName = this.tableData1[2].name;
                    this.all = this.setTableData().length;
                    this.getPages();
                });
            },
            //刷新页面
            add() {
                this.$router.go(0);
            },
            //判断当前tabs的值
            tableLocal() {
                if (window.sessionStorage.getItem("tast") != null) {
                    this.activeName = sessionStorage.getItem("tast");
                } else {

                    this.activeName = this.tableData1[2].name;
                }
            },

            carTimeFilter(row, column, cellValue, index) {
                const daterc = row[column.property];
                if (daterc != null) {
                    return moment(daterc).format("YYYY年MM月DD日 HH:mm");
                }
            },
            eventType(row, column, cellValue, index) {
                // DEVICE_FAILURE
                if (cellValue === "OPENING_AND_CLOSING") {
                    return "分合闸";
                } else if (cellValue === "TELEMETRY_OVERRUN") {
                    return "越限异常";
                } else if (cellValue === "DEVICE_FAILURE") {
                    return "回路故障";
                } else if (cellValue === "TELEMETRY_DISPLACEMENT") {
                    return "分合闸事件";
                }
            },

            handleClick(e) {
                window.sessionStorage.setItem("tast", e.name);
                this.activeName == e.name;
                this.all = this.setTableData().length;
                this.currentPage = 1;
                this.getPages();
            },
            prev() {
                let length = this.all;
                this.first = this.first - 8 < 1 ? 1 : this.first - 8;
                this.end = this.first + 7 > length ? length : this.first + 7;
                this.tableData = this.setTableData().slice(this.first - 1, this.end);
                this.currentPage = this.end / 8;
            },
            next() {
                let length = this.all;
                this.first = this.first + 8 < length ? this.first + 8 : this.first;
                this.end = this.end + 8 < length ? this.end + 8 : length;
                this.tableData = this.setTableData().slice(this.first - 1, this.end);
                this.currentPage = Math.ceil(this.end / 8);
            },
            toEnd() {
                let length = this.all;
                this.first = length - (length % 8) + 1;
                this.end = length;
                this.tableData = this.setTableData().slice(this.first - 1, this.end);
                this.currentPage = Math.ceil(this.end / 8);
            },
            toFirst() {
                let length = this.all;
                this.first = 1;
                this.end = 8 < length ? 8 : length;
                this.tableData = this.setTableData().slice(this.first - 1, this.end);
                this.currentPage = Math.ceil(this.end / 8);
            },
            //改变表头
            //改变table颜色
            tableHeaderColor({
                rowIndex
            }) {
                if (rowIndex === 0) {
                    return "background-color:#E0E5EC;color: #000000;font-weight: 500;";
                }
            },
            pageCurrentChange() {
                let length = this.all;
                let first = (this.currentPage - 1) * 8;
                this.first = first + 1 < length ? first + 1 : 1;
                this.end = this.currentPage * 8 < length ? this.currentPage * 8 : length;
                this.tableData = this.setTableData().slice(this.first - 1, this.end);
            },
            //表格颜色
            //改变table颜色
            tableRowClassName({
                rowIndex
            }) {
                if (rowIndex % 2 != 0) {
                    //=>这里可以改成 rowIndex%2=== 1，后面直接else即可达到隔行变色效果。
                    return "background-color:#FAFBFC;";
                }
                return "";
            },
            async getPages() {
                if (this.all == 0) {
                    this.first = 0;
                    this.end = 0;
                    this.tableData = [];
                } else {
                    this.first = 1;
                    this.end = this.all < 8 ? this.all : 8;
                    this.tableData = this.setTableData().slice(this.first - 1, this.end);
                }
            },
        },
    };
</script>

<style lang="less">
    .head {
        width: 100%;
        height: 48rem;
        display: flex;
        margin-bottom: 24rem;

        .name {
            width: 440rem;
            height: 100%;
            background: #ffffff;
            display: flex;
            // padding: 12rem 17rem 0 24rem;
            justify-content: center;
            align-items: center;

            .spa {
                // width: 252rem;
                font-size: 26rem;
                font-weight: 400;
                color: #333333;
                margin-left: 17rem;
                font-weight: 400;
                // line-height: 44rem;
                font-family: "YouSheBiaoTiHei-2";
                text-align: center;
                // display: flex;
                // align-items: center;
            }

            .oimg {
                width: 24rem;
                height: 24rem;

                img {
                    width: 24rem;
                    height: 24rem;
                }
            }
        }

        // .tatel {
        //     width: 560rem;
        //     height: 48rem;
        //     background: #ffffff;
        //     border: 1rem solid rgba(0, 0, 0, 0.01);
        //     padding: 12rem 0 12rem 24rem;
        //     box-shadow: 0rem 3rem 14rem 0rem rgba(3, 13, 24, 0.26);
        //     border-radius: 0rem 0rem 8rem 8rem;
        //     display: flex;
        //     align-items: center;
        //     text-align: center;

        //     .miti {
        //         width: 22rem;
        //         height: 22rem;

        //         i {
        //             font-size: 22rem;
        //             color: chocolate;
        //         }
        //     }

        //     .mixin {
        //         margin-left: 18rem;
        //         font-size: 24rem;
        //         font-weight: 400;
        //         margin-top: -2rem;
        //         // color: #cccccc;
        //         color: #666666;
        //         overflow: hidden;
        //         text-overflow: ellipsis;
        //         white-space: nowrap;
        //     }
        // }
    }

    .cinema {
        padding: 0 24rem;
    }

    .content {
        width: 1392rem;
        height: 760rem;
        display: flex;
        flex-direction: column;
        align-items: center;

        //   padding: 0 24rem;
        .table {
            width: 1392rem;
            display: flex;
            flex-direction: row;
            align-items: baseline;
        }

        .nav {
            width: 1392rem;
            height: 75rem;
            display: flex;
            flex-direction: row;
            justify-content: space-between;

            .nav-left {
                width: 300rem;
                justify-content: space-between;
                display: flex;
                flex-direction: row;
                align-items: center;
            }

            .el-tabs--card>.el-tabs__header {
                border: 0;
            }

            .el-tabs--card>.el-tabs__header .el-tabs__item.is-active {
                color: white;
            }

            .el-tabs--card>.el-tabs__header .el-tabs__nav {
                width: 300rem;
                display: flex;
                justify-content: space-between;
                align-items: center;
                border: none;
            }

            .el-tabs--card>.el-tabs__header .el-tabs__item {
                border: 1rem solid #d9d9d9;
                width: 84rem;
                display: flex;
                align-items: center;
                justify-content: center;
            }

            .el-tabs__item {
                font-size: 18rem;
                // font-weight: 600;
            }

            .el-tabs__item:hover {
                color: #000000;
                cursor: pointer;
            }

            .el-tabs__item.is-active {
                color: #000;

                background: linear-gradient(rgba(3, 13, 24, 0.65),
                        rgba(3, 13, 24, 0.5),
                        rgba(3, 13, 24, 0.65));
            }

            .nav-right {
                width: 200rem;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: flex-end;
            }

            .button {
                width: 84rem;
                height: 40rem;
                border: 1rem solid rgba(0, 0, 0, 0.15);
                border-radius: 2rem;
                cursor: pointer;
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }

        .pagination {
            height: 6vh;
            //width: 300rem;
            align-self: flex-end;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-evenly;
            font-size: 14rem;

            .button {
                width: 74rem;
                height: 24rem;
                border: 1rem solid rgba(0, 0, 0, 0.15);
                border-radius: 2rem;
                cursor: pointer;
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }

        .column-center {
            display: flex;
            flex-flow: column wrap;
            justify-content: center;
            align-items: center;
        }

        .mar {
            margin: auto;

            .tors {
                width: 400rem;
                height: 400rem;
                // margin: auto;
                // background-color: red;
                text-align: center;

                .Omg {
                    margin: auto;
                    width: 240rem;
                    height: 224rem;

                    img {
                        width: 240rem;
                        height: 224rem;
                    }
                }

                .oP {
                    font-size: 18rem;
                    font-weight: 400;
                    color: #999999;
                    margin-top: 24rem;
                }

                .a {
                    cursor: pointer;
                }
            }
        }
    }
</style>